export const WhitelistRoute = {
  "/privacy-policy": true,
  "/signin": true,
  "/signup": true,
  "/reset-password": true,
};
